var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "DialogLinkTasksToCourse__Component",
      attrs: { dir: "rtl" },
    },
    [
      _c("div", { staticClass: "modal-card" }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title" }, [
            _vm._v("שיוך משימות לקורס"),
          ]),
          _c("button", {
            staticClass: "delete",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ]),
        _c(
          "section",
          { staticClass: "modal-card-body" },
          [
            _c("p", { staticClass: "DialogLinkTasksToCourse__Count" }, [
              _vm._v(" נבחרו "),
              _c("b", [_vm._v(_vm._s(_vm.tasks.length))]),
              _vm._v(" משימות לשיוך. "),
            ]),
            _c(
              "b-field",
              { attrs: { label: "קורס:" } },
              [
                _c("FieldInlineSelect", {
                  attrs: {
                    label: "קורס",
                    filterable: true,
                    clearable: true,
                    optionsAsync: _vm.getCourses,
                  },
                  model: {
                    value: _vm.courseId,
                    callback: function ($$v) {
                      _vm.courseId = $$v
                    },
                    expression: "courseId",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "DialogLinkTasksToCourse__Note" }, [
              _vm._v(
                " המשימות ישויכו לקורס שנבחר. שיוך חוזר של משימה שכבר משויכת אינו יוצר כפילות. "
              ),
            ]),
          ],
          1
        ),
        _c(
          "footer",
          { staticClass: "modal-card-foot" },
          [
            _c("b-button", {
              attrs: {
                loading: _vm.isLoading,
                disabled: !_vm.courseId,
                label: "שייך",
                type: "is-primary",
              },
              on: { click: _vm.save },
            }),
            _c("b-button", {
              attrs: { disabled: _vm.isLoading, label: "סגור" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }